import React from 'react';
import FinishCallModal from './FinishCallModal';
import ReasignCallModal from './ReassignCallModal';

export default function TicketActionsModals() {
  function getContainer() {
    let container = document
      .querySelector('.mainContainer .reactivo-tabs.gmTabs #ticketActionsModalWrapper');

    if (!container) {
      container = document.createElement('div');
      container.id = 'ticketActionsModalWrapper';

      document.querySelector('.mainContainer .reactivo-tabs.gmTabs').appendChild(container);
    }

    return container;
  }

  return (
    <div id="ticketActionsModalWrapper">
      <FinishCallModal parentSelector={() => getContainer()} />
      <ReasignCallModal parentSelector={() => getContainer()} />
    </div>
  );
}
